import actions from '@/modules/common/store/entityActions'
import EntityState from '@/modules/common/store/entityState'
import getters from '@/modules/common/store/entityGetters'
import { Module } from 'vuex'
import mutations from '@/modules/common/store/entityMutations'
import userService from '@/modules/user/services/userService'
import RootState from '@/store/rootState'
import User from '@/modules/user/domain/user'

const contactModule: Module<EntityState<User>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(userService, 'user')
}

export default contactModule
